import { ADMIN_ROUTES } from '~/constants/router'
import { adminRoles, dashboardRoles } from '~/modules/auth/conditions'
import { lazyRetry } from '~/utils/lazyRetry'

const WooDashboard = lazyRetry(() => import('~/pages/Dashboard/woo'))
const CovaDashboard = lazyRetry(() => import('~/pages/Dashboard/cova'))
const GreenlineDashboard = lazyRetry(
  () => import('~/pages/Dashboard/greenline'),
)
const FlowhubDashboard = lazyRetry(() => import('~/pages/Dashboard/flowhub'))
const LightspeedDashboard = lazyRetry(
  () => import('~/pages/Dashboard/lightspeed'),
)
const PantryDashboard = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.DashboardPage })),
)
const AdminOptions = lazyRetry(() => import('~/pages/AdminOptions'))
const Profile = lazyRetry(() => import('~/pages/Profile'))
const Home = lazyRetry(() => import('~/pages/Home'))
const Settings = lazyRetry(() => import('~/pages/Settings/WooSetting'))
const PantrySetting = lazyRetry(() => import('~/pages/Settings/PantrySetting'))
const EcommerceSetting = lazyRetry(() => import('~/pages/Settings/Ecommerce'))
const PosSetting = lazyRetry(() => import('~/pages/Settings/Pos'))
const Users = lazyRetry(() => import('~/pages/Settings/Users'))
const Locations = lazyRetry(() => import('~/pages/Settings/Locations'))
const Waybill = lazyRetry(() => import('~/pages/Settings/Waybill'))
const IntegrationsSetting = lazyRetry(
  () => import('~/pages/Settings/Integrations'),
)
const IntegrationsProfile3 = lazyRetry(
  () => import('~/pages/Settings/IntegrationsProfile3'),
)
const CompanySetting = lazyRetry(() => import('~/pages/Settings/Company'))
const PantryBilling = lazyRetry(() => import('~/pages/Settings/PantryBilling'))
const EmailMarketing = lazyRetry(
  () => import('~/pages/Settings/EmailMarketing'),
)
const MyAccount = lazyRetry(() => import('~/pages/Account/MyAccount'))
const Notification = lazyRetry(() => import('~/pages/Account/NotificationV2'))
const ChatShortcuts = lazyRetry(() => import('~/pages/Account/ChatShortcuts'))
const Tags = lazyRetry(() => import('~/pages/Tag/TagListV2'))
const BrandList = lazyRetry(() => import('~/pages/Brand/BrandList'))
const PantryBrandList = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.BrandPage })),
)
const PantryLocationList = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.LocationPage })),
)
const PantryEcommerceSetting = lazyRetry(
  () => import('./PantryEcommerceWrapper'),
)
const PantryUserList = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.UserPage })),
)
const PantryLoyalty = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.LoyaltyPage })),
)
const PantryLoyaltySegmentBuilder = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.SegmentBuilderPage })),
)
const PantryLoyaltySegmentDetail = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.SegmentDetailPage })),
)
const PantryLoyaltyCampaignBuilder = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.CampaignBuilderPage })),
)
const PantryStorefrontAnalytics = lazyRetry(() =>
  import('@pantry/features').then((m) => ({
    default: m.StorefrontAnalyticsPage,
  })),
)
const CategoryList = lazyRetry(() => import('~/pages/Category/CategoryListV2'))
const CovaCategoryDetail = lazyRetry(
  () => import('~/pages/Category/CovaCategoryDetail'),
)
const GreenlineCategoryDetail = lazyRetry(
  () => import('~/pages/Category/GreenlineCategoryDetail'),
)
const FlowhubCategoryDetail = lazyRetry(
  () => import('~/pages/Category/FlowhubCategoryDetail'),
)
const LightspeedCategoryDetail = lazyRetry(
  () => import('~/pages/Category/LightspeedCategoryDetail'),
)
const NotificationCenter = lazyRetry(() => import('~/pages/Notification'))
const ComingSoon = lazyRetry(() => import('~/pages/ComingSoon'))

const AdminRouter = [
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.WOO_SETTINGS}/:id?/:tab?`,
    component: Settings,
    layout: 'admin',
    exact: true,
    routeName: 'Setting',
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/users/:userId?`,
    component: Users,
    pantryComponent: PantryUserList,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Users',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/locations/:locationId?/:tab?`,
    component: Locations,
    pantryComponent: PantryLocationList,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Locations',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/ecommerce/:tab?/:id?`,
    component: EcommerceSetting,
    pantryComponent: PantryEcommerceSetting,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Ecommerce',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/waybill`,
    component: Waybill,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Waybill',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/pos/:tab?`,
    component: PosSetting,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Pos',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/integrations/:site?`,
    component: IntegrationsSetting,
    covaComponent: IntegrationsProfile3,
    greenlineComponent: IntegrationsProfile3,
    flowhubComponent: IntegrationsProfile3,
    lightspeedComponent: IntegrationsProfile3,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Integrations',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/company`,
    component: CompanySetting,
    // pantryComponent: PantryBilling,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Company',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/email-marketing`,
    component: EmailMarketing,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Email Marketing',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/tags`,
    component: Tags,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Tags',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.ACCOUNT}/my-account`,
    component: MyAccount,
    layout: 'admin',
    exact: true,
    routeName: 'Account - My Account',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.ACCOUNT}/notification`,
    component: Notification,
    layout: 'admin',
    exact: true,
    routeName: 'Account - Notification',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.ACCOUNT}/chat-shortcuts`,
    component: ChatShortcuts,
    layout: 'admin',
    exact: true,
    routeName: 'Account - My Account',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.ADMIN_OPTIONS}/:id?/:tab?/:action?`,
    component: AdminOptions,
    layout: 'admin',
    exact: true,
    routeName: 'Admin Options',
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.USER_PROFILE}`,
    component: Profile,
    layout: 'admin',
    exact: true,
    routeName: 'User Profile',
  },
  {
    path: `${ADMIN_ROUTES.STORE}`,
    component: WooDashboard,
    pantryComponent: PantryDashboard,
    covaComponent: CovaDashboard,
    greenlineComponent: GreenlineDashboard,
    flowhubComponent: FlowhubDashboard,
    layout: 'admin',
    exact: true,
    routeName: 'Dashboard',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.DASHBOARD}`,
    component: WooDashboard,
    pantryComponent: PantryDashboard,
    covaComponent: CovaDashboard,
    greenlineComponent: GreenlineDashboard,
    flowhubComponent: FlowhubDashboard,
    lightspeedComponent: LightspeedDashboard,
    layout: 'admin',
    routeName: 'Dashboard',
    roles: dashboardRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.DASHBOARD_SERVICE}`,
    component: WooDashboard,
    pantryComponent: PantryDashboard,
    covaComponent: CovaDashboard,
    greenlineComponent: GreenlineDashboard,
    flowhubComponent: FlowhubDashboard,
    layout: 'admin',
    routeName: 'Dashboard',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.DASHBOARD_MARKETING}`,
    component: WooDashboard,
    pantryComponent: PantryDashboard,
    covaComponent: CovaDashboard,
    greenlineComponent: GreenlineDashboard,
    flowhubComponent: FlowhubDashboard,
    layout: 'admin',
    routeName: 'Dashboard',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.HOME}`,
    component: Home,
    covaComponent: Home,
    greenlineComponent: Home,
    layout: 'admin',
    routeName: 'Home',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/categories`,
    component: CategoryList,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Category List',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/categories/:categoryId/edit`,
    covaComponent: CovaCategoryDetail,
    greenlineComponent: GreenlineCategoryDetail,
    flowhubComponent: FlowhubCategoryDetail,
    lightspeedComponent: LightspeedCategoryDetail,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Category Edit',
    bsTheme: true,
    roles: adminRoles,
    xProps: {
      isEditing: true,
    },
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/categories/create`,
    covaComponent: CovaCategoryDetail,
    greenlineComponent: GreenlineCategoryDetail,
    flowhubComponent: FlowhubCategoryDetail,
    lightspeedComponent: LightspeedCategoryDetail,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Category Create',
    bsTheme: true,
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.NOTIFICATION_CENTER}`,
    component: NotificationCenter,
    layout: 'admin',
    exact: true,
    routeName: 'Activities',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/brands`,
    component: BrandList,
    pantryComponent: PantryBrandList,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Brand List',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/segments/builder/:segmentId?`,
    component: PantryLoyaltySegmentBuilder,
    pantryComponent: PantryLoyaltySegmentBuilder,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty Segment Builder',
    bsTheme: true,
  },
  // Segment detail (customer table). Declared after the builder route so the
  // literal `builder` segment is never read as a segment id.
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/segments/:segmentId`,
    component: PantryLoyaltySegmentDetail,
    pantryComponent: PantryLoyaltySegmentDetail,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty Segment Detail',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/campaigns/builder`,
    component: PantryLoyaltyCampaignBuilder,
    pantryComponent: PantryLoyaltyCampaignBuilder,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty Campaign Builder',
    bsTheme: true,
  },
  // Edit an existing always-on flow. Declared before the campaign-edit route:
  // the literal `flow` segment must not be read as a campaign id.
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/campaigns/builder/flow/:flowId`,
    component: PantryLoyaltyCampaignBuilder,
    pantryComponent: PantryLoyaltyCampaignBuilder,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty Flow Builder',
    bsTheme: true,
  },
  // Edit an existing campaign.
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/campaigns/builder/:campaignId`,
    component: PantryLoyaltyCampaignBuilder,
    pantryComponent: PantryLoyaltyCampaignBuilder,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty Campaign Builder',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}/loyalty/:tabId?`,
    component: PantryLoyalty,
    pantryComponent: PantryLoyalty,
    layout: 'admin',
    exact: true,
    routeName: 'Loyalty',
    bsTheme: true,
  },
  // Storefront Analytics: the thermometer's reports for this store's pantry
  // sites. The backend's sidebar only lists it for the pilot logins.
  {
    path: `${ADMIN_ROUTES.STORE}/storefront-analytics/:page?`,
    component: PantryStorefrontAnalytics,
    pantryComponent: PantryStorefrontAnalytics,
    layout: 'admin',
    exact: true,
    routeName: 'Storefront Analytics',
    bsTheme: true,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/:tab?`,
    component: Settings,
    pantryComponent: PantrySetting,
    layout: 'admin',
    exact: true,
    routeName: 'Setting',
    roles: adminRoles,
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.COMING_SOON}`,
    component: ComingSoon,
    pantryComponent: ComingSoon,
    exact: true,
    layout: 'admin',
    routeName: 'Coming Soon',
  },
]

export default AdminRouter
